
    export default {
        props : ['slides','timeout'],
        data() { return {currentSlide : 0} },
        mounted() {
            setInterval(() => this.currentSlide = (this.currentSlide + 1) % this.slides.length, this.timeout || 4000);
        }
    }
